var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBnkDetails(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    width: "237px",
    height: "237px",
    viewBox: "-3.6 -3.6 43.20 43.20",
    preserveAspectRatio: "xMidYMid meet",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    stroke: "#000000",
    strokeWidth: 0.00036,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0,
    transform: "translate(0,0), scale(1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -3.6,
    y: -3.6,
    width: 43.2,
    height: 43.2,
    rx: 0,
    fill: "#e5e7eb",
    strokeWidth: 0
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("title", null, "details-line"), /*#__PURE__*/React.createElement("path", {
    d: "M32,6H4A2,2,0,0,0,2,8V28a2,2,0,0,0,2,2H32a2,2,0,0,0,2-2V8A2,2,0,0,0,32,6Zm0,22H4V8H32Z",
    className: "clr-i-outline clr-i-outline-path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9,14H27a1,1,0,0,0,0-2H9a1,1,0,0,0,0,2Z",
    className: "clr-i-outline clr-i-outline-path-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9,18H27a1,1,0,0,0,0-2H9a1,1,0,0,0,0,2Z",
    className: "clr-i-outline clr-i-outline-path-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9,22H19a1,1,0,0,0,0-2H9a1,1,0,0,0,0,2Z",
    className: "clr-i-outline clr-i-outline-path-4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 36,
    height: 36,
    fillOpacity: 0
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBnkDetails);
export default __webpack_public_path__ + "static/media/bnk-details.6b9a488fd8b547f60f4dbad4380e8daa.svg";
export { ForwardRef as ReactComponent };